/*eslint-disable*/
import { Link } from "gatsby"
import React, { useState } from "react"
import * as classes from "./styles.module.scss"
import clsx from "clsx"

// reactstrap components
import {
  Container,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
} from "reactstrap"
// import "./FooterBlack.scss";

// core components

function FooterBlack() {
  const [collapseOpen, setCollapseOpen] = useState(false)

  const handleClick = (slug) => {}
  const handleCollapseNavbar = () => {
    if (window.innerWidth <= 991) {
      document.documentElement.classList.toggle("nav-open")
      setCollapseOpen(!collapseOpen)
    }
  }

  return (
    <>
      <footer
        className={clsx("footer", classes.footer)}
        data-background-color="black"
      >
        <Navbar className={classes.navBar}>
          <Container className={classes.container}>
            <Nav
              className={clsx("ml-auto", classes.navWrapper)}
              id="ceva"
              navbar
            >
              <UncontrolledDropdown nav>
                <DropdownToggle
                  color="default"
                  id="navbarDropdownMenuLink"
                  nav
                  tag={Link}
                  to="/"
                  onClick={handleCollapseNavbar}
                >
                  <p>Home</p>
                </DropdownToggle>
              </UncontrolledDropdown>
              {/* <UncontrolledDropdown nav>
                <DropdownToggle
                  color="default"
                  id="navbarDropdownMenuLink"
                  nav
                  tag={Link}
                  to="/about-us"
                  onClick={handleCollapseNavbar}
                >
                  <p>About Us</p>
                </DropdownToggle>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav>
                <DropdownToggle
                  color="default"
                  id="navbarDropdownMenuLink"
                  nav
                  tag={Link}
                  to="/#contact-us"
                  onClick={handleCollapseNavbar}
                >
                  <p>Contact Us</p>
                </DropdownToggle>
              </UncontrolledDropdown> */}
              <UncontrolledDropdown nav>
                <DropdownToggle
                  color="default"
                  id="navbarDropdownMenuLink"
                  nav
                  tag={Link}
                  to="/main-services"
                  onClick={handleCollapseNavbar}
                >
                  <p>Services</p>
                </DropdownToggle>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav>
                <DropdownToggle
                  color="default"
                  id="navbarDropdownMenuLink"
                  nav
                  tag={Link}
                  to="/enquiry"
                  onClick={handleCollapseNavbar}
                >
                  <p>Enquiry</p>
                </DropdownToggle>
              </UncontrolledDropdown>
            </Nav>
          </Container>
        </Navbar>
      </footer>
    </>
  )
}

export default FooterBlack
